import InsufficientPermissionsPage from 'components/core/InsufficientPermissionsPage/InsufficientPermissionsPage';
import { isDefined } from 'shared/domain/role/isDefined';
import { isStandard } from 'shared/domain/role/isStandard';
import React from 'react';
import { useCurrentUserRole } from 'store/user';
import { MemoInspection } from 'views/inspections/single';
import { MemoInspections } from 'views/inspections/table';
import { MemoInspectionWizard } from 'views/inspections/wizard';
import { MemoGenericRoleAuthorizer } from '../GenericRoleAuthorizer';

export const AuthorizableInspection = React.memo(
  (): React.ReactElement => {
    const role = useCurrentUserRole();

    const isCurrentUserAuthorized = isDefined(role) && !isStandard(role);

    return (
      <MemoGenericRoleAuthorizer
        authorized={isCurrentUserAuthorized}
        unauthorized={isStandard(role)}
        authorizedComponent={MemoInspection}
        unauthorizedComponent={InsufficientPermissionsPage}
      />
    );
  }
);

export const AuthorizableInspectionWizard = React.memo(
  (): React.ReactElement => {
    const role = useCurrentUserRole();

    const isCurrentUserAuthorized = isDefined(role) && !isStandard(role);
    return (
      <MemoGenericRoleAuthorizer
        authorized={isCurrentUserAuthorized}
        unauthorized={isStandard(role)}
        authorizedComponent={MemoInspectionWizard}
        unauthorizedComponent={InsufficientPermissionsPage}
      />
    );
  }
);

export const AuthorizableInspections = React.memo(
  (): React.ReactElement => {
    const role = useCurrentUserRole();

    const isCurrentUserAuthorized = isDefined(role) && !isStandard(role);
    return (
      <MemoGenericRoleAuthorizer
        authorized={isCurrentUserAuthorized}
        unauthorized={isStandard(role)}
        authorizedComponent={MemoInspections}
        unauthorizedComponent={InsufficientPermissionsPage}
      />
    );
  }
);
